import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueCookie from "vue-cookie";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Viewer from "v-viewer";
import cloneDeep from "lodash/cloneDeep";
import Format from './utils/formater'
import * as echarts from 'echarts'

import plugins from "./plugins/plugins";
import httpRequest from "@utils/httpRequest";
import { isAuth } from "@utils/index";
import "@/assets/icons/index.js";
import "@imgs/o_icons/index.js";
import "@assets/css/index.less";
// import "@assets/css/index.css";
import Icon from "@imgs/o_icons/index.js"
Icon.getNameList()


Vue.use(plugins);
Vue.use(ElementUI);
Vue.use(VueCookie);
Vue.prototype.$format = Format;


Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
Vue.prototype.$axios = axios;
Vue.prototype.$http = httpRequest;
Vue.prototype.isAuth = isAuth;
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;

// 保存整站vuex本地储存初始状态
window["storeState"] = cloneDeep(store.state);

new Vue({
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
		Vue.prototype.$bus = this //安装全局事件总线，$bus就是当前应用的vm
	},
}).$mount("#app");
